import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/auth';
//import chatReducer from '../chat/store/reducer'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    // activity: activityReducer,
    //chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    //serializableCheck: false,
  }),
});
